import { render } from "./CTIForm.vue?vue&type=template&id=18d166a4"
import script from "./CTIForm.vue?vue&type=script&lang=js"
export * from "./CTIForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__